import { NodeModel } from "../_model/NodeModel";
import { DecorationHeater } from "./decorationHeater";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Heater extends NodeModel {
  constructor() {
    super("Heater");

    this.type = new Types().Heater;
    this.x = 0;
    this.y = 0;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;
    this.height = 140;
    this.width = 130;
    this.operationSelected = "";
    this.showOutletTemperature = false;
    this.srcImg = require("@/assets/Fluxogramas/aquecedor.png");
    this.jokerCaption = [];
    this.data = [new Properties({...this })];

    this.decorate = async function(callback) {
      this.decorator = new DecorationHeater();
      await this.decorator.init(this, callback);
    };

    this.clone = () => {
      let cloned = new Heater();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.readOnly = this.readOnly;
      cloned.decorator = null;
      cloned.showOutletTemperature = this.showOutletTemperature;
      cloned.expressionVisible = this.expressionVisible;
      cloned.data = this.data.map((d) => d.clone());
      cloned.jokerCaption = this.jokerCaption;

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.showOutletTemperature = node.showOutletTemperature;
      this.jokerCaption = node.jokerCaption;
      this.data = node.data.map((d) => new Properties({ ...d }));
    };

    this.update = (node) => {
      if (node.attrs) {
        this.data = node.attrs;
      }

      this.showOutletTemperature = node.showOutletTemperature;
      this.jokerCaption = node.jokerCaption;
      this.expressionVisible = node.expressionVisible;
    };

    this.rebuildStructure = (newProps = []) => {
      let newData = [];
      this.jokerCaption = [];

      newProps.forEach(prop => {
        let enabled = prop.key == "Enabled" && prop.subType == "Atributos";
        let equipments = prop.subType == "Equipamentos" && prop.key == "Status";
        let area = prop.key == "area" && prop.subType == "Atributos"
        let Tsaida = prop.key == "TSaida" && this.showOutletTemperature && prop.subType == "Atributos"
        
        if (enabled || equipments || area || Tsaida) {
          newData.push(prop);
        }
        
      });
      this.data = newData;
    }
  }
}

export { Heater };
